// Kept apart from store/index.js, which registers the stores (and asks /api/user for guests) as soon as it's
// imported: the component bundles that import these from there got a second copy of it, so every guest page view
// sent /api/user twice and registered every store twice. Nothing in here may run on import.

let localStorageAvailable
/** Most backwards compatible way of testing if localStorage is available */
export function isLocalStorageAvailable() {
    if (localStorageAvailable !== undefined) {
        return localStorageAvailable
    }

    const test = '_test_'
    try {
        if (!localStorage) return false

        localStorage.setItem(test, test)
        localStorage.removeItem(test)
        localStorageAvailable = true
    } catch (e) {
        localStorageAvailable = false
    }
    return localStorageAvailable
}

let sessionStorageAvailable
/** Most backwards compatible way of testing if sessionStorage is available */
export function isSessionStorageAvailable() {
    if (sessionStorageAvailable !== undefined) {
        return sessionStorageAvailable
    }

    const test = '_test_'
    try {
        if (!sessionStorage) return false

        sessionStorage.setItem(test, test)
        sessionStorage.removeItem(test)
        sessionStorageAvailable = true
    } catch (e) {
        sessionStorageAvailable = false
    }
    return sessionStorageAvailable
}
